import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BarChart2Icon, UsersIcon, LineChartIcon, LayoutIcon, BriefcaseIcon, SearchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const services = [{
  icon: <UsersIcon size={24} data-id="element-22" />,
  title: 'Consumer & Lifestyle Insights',
  description: "Uncover the behaviors, preferences, and trends that drive consumer decisions in Toronto's diverse markets."
}, {
  icon: <LayoutIcon size={24} data-id="element-23" />,
  title: 'Brand Perception & Ad Testing',
  description: 'Optimize your brand messaging and advertising effectiveness through rigorous testing methodologies.'
}, {
  icon: <SearchIcon size={24} data-id="element-24" />,
  title: 'UX & Product Research',
  description: 'Design better digital experiences with user testing and product research tailored to your target audience.'
}, {
  icon: <LineChartIcon size={24} data-id="element-25" />,
  title: 'Urban Planning & Infrastructure',
  description: 'Support smart city initiatives with data-driven insights on urban mobility, housing, and public services.'
}, {
  icon: <BriefcaseIcon size={24} data-id="element-26" />,
  title: 'Sports & Entertainment Trends',
  description: "Tap into Toronto's vibrant sports and entertainment culture with specialized audience research."
}, {
  icon: <BarChart2Icon size={24} data-id="element-27" />,
  title: 'Qualitative & Quantitative Research',
  description: 'Comprehensive research solutions combining in-depth interviews, focus groups, surveys, and statistical analysis.'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
const FeaturedServices = () => {
  return <section className="py-20 bg-white" data-id="element-28">
      <div className="container mx-auto px-4 md:px-6" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-31">
            Our <span className="text-toronto-blue" data-id="element-32">Services</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="text-lg text-neutral-dark/80 max-w-2xl mx-auto" data-id="element-33">
            Comprehensive research solutions tailored to Toronto's unique
            multicultural landscape and global business needs.
          </motion.p>
        </div>
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-34">
          {services.map((service, index) => <motion.div key={index} variants={item} className="bg-neutral-light rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-35">
              <div className="bg-toronto-blue/10 rounded-full w-12 h-12 flex items-center justify-center mb-4 text-toronto-blue" data-id="element-36">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-37">{service.title}</h3>
              <p className="text-neutral-dark/80 mb-4" data-id="element-38">{service.description}</p>
              <Link to="/services" className="text-toronto-blue font-medium inline-flex items-center hover:underline" data-id="element-39">
                Learn more
              </Link>
            </motion.div>)}
        </motion.div>
        <div className="text-center mt-12" data-id="element-40">
          <Link to="/services" data-id="element-41">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-transparent border-2 border-toronto-blue text-toronto-blue hover:bg-toronto-blue/10 font-medium px-6 py-3 rounded transition-colors" data-id="element-42">
              View All Services
            </motion.button>
          </Link>
        </div>
      </div>
    </section>;
};
export default FeaturedServices;